module.exports = __webpack_public_path__ + "static/media/cement.99c8d4af.jpg";